export const socialMediaTranslation = {
  en: {
    Home: "Home",
    Settings: "Settings",
    Landing: "Landing",
    "Social Media": "Social Media",
    "Facebook URL": "Facebook URL",
    "YouTube URL": "YouTube URL",
    "LinkedIn URL": "LinkedIn URL",
    "TikTok URL": "TikTok URL",
    "Snapchat URL": "Snapchat URL",
    "Twitter/X URL": "Twitter/X URL",
    "Enter Facebook URL": "Enter Facebook URL",
    "Enter YouTube URL": "Enter YouTube URL",
    "Enter LinkedIn URL": "Enter LinkedIn URL",
    "Enter TikTok URL": "Enter TikTok URL",
    "Enter Snapchat URL": "Enter Snapchat URL",
    "Enter Twitter/X URL": "Enter Twitter/X URL",
    Update: "Update",
    "If the social media link is empty, it will be considered as hidden.":
      "If the social media link is empty, it will be considered as hidden.",
  },
  ar: {
    Home: "الصفحة الرئيسية",
    Settings: "الإعدادات",
    Landing: "الموقع التعريفي",
    "Social Media": "وسائل التواصل الاجتماعي",
    "Facebook URL": "رابط فيسبوك",
    "YouTube URL": "رابط يوتيوب",
    "LinkedIn URL": "رابط لينكد إن",
    "TikTok URL": "رابط تيك توك",
    "Snapchat URL": "رابط سناب شات",
    "Twitter/X URL": "رابط تويتر/X",
    "Enter Facebook URL": "أدخل رابط فيسبوك",
    "Enter YouTube URL": "أدخل رابط يوتيوب",
    "Enter LinkedIn URL": "أدخل رابط لينكد إن",
    "Enter TikTok URL": "أدخل رابط تيك توك",
    "Enter Snapchat URL": "أدخل رابط سناب شات",
    "Enter Twitter/X URL": "أدخل رابط تويتر/X",
    Update: "تحديث",
    "If the social media link is empty, it will be considered as hidden.":
      "إذا كان رابط وسائل التواصل الاجتماعي فارغًا، فسيتم اعتباره مخفيًا.",
  },
};
